<template>
    <div class="wrapper-registro cover-login">
        <div class="popup -full">

            <ValidationObserver ref="form" v-slot="{ failed, valid }">
                <form class="paso row-between fww" @submit.prevent="validate" :valid="valid" autocomplete="new-text">
                    <h2 class="titulo left">Formulario de registro Alumni, Elumni & Friends</h2>

                    <div class="contenedor-input half">
                        <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                            <input autocomplete="new-password" type="text" name="nombre" placeholder="Nombre*"
                                v-model="data.name" :class="classes">
                            <span v-bind="ariaMsg" v-if="errors[0]" class="custom-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>

                    <div class="contenedor-input half">
                        <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                            <input autocomplete="new-password" type="text" name="apellido-uno" placeholder="Apellido 1*"
                                v-model="data.surname" :class="classes">
                            <span v-bind="ariaMsg" v-if="errors[0]" class="custom-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="campo-texto">
                        <div class="contenedor-input half">
                            <input autocomplete="new-password" type="text" name="apellido-dos" placeholder="Apellido 2"
                                v-model="data.surname_2">
                        </div>

                        <div class="contenedor-input half">
                            <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                                <select id="tipodocumento" name="tipodocumento" v-model="data.document_type"
                                    class="pretty" :class="classes">
                                    <option name="myBrowser" placeholder="" disabled value="">Tipo de documento*
                                    </option>
                                    <option :key="key" v-for="(tipo, key) in dominios.tiposdocumento" name="myBrowser"
                                        :value="key">
                                        {{ tipo }}</option>
                                </select>
                                <span v-bind="ariaMsg" v-if="errors[0]" class="custom-error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="contenedor-input half">
                        <ValidationProvider :rules="(data.document_type != 1) ? 'required|validdni' : 'required'"
                            v-slot="{ errors, ariaInput, ariaMsg, classes }">
                            <input autocomplete="new-password" type="text" name="dni"
                                :placeholder="(data.document_type) ? dominios.tiposdocumento[data.document_type] : 'Documento*'"
                                v-model="data.document" :class="classes">
                            <span v-bind="ariaMsg" v-if="errors[0]" class="custom-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>

                    <div class="contenedor-input half">
                        <ValidationProvider rules="required|email|email_es_com" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                            <input autocomplete="new-password" type="email" name="mail" placeholder="Mail*"
                                v-model="data.email" :class="classes">
                            <span v-bind="ariaMsg" v-if="errors[0]" class="custom-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="campo-texto pb-0">
                        <div class="contenedor-input half movil pb-0">
                            <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                                <input autocomplete="new-password" type="text" name="movil" placeholder="Móvil*"
                                    v-model="data.phone" :class="classes">
                                <p class="msg-info-tel">Por favor no utilices ni espacios ni símbolos, si tienes un
                                    teléfono
                                    extranjero indica el
                                    prefijo con 00 en vez de con +</p>
                                <span v-bind="ariaMsg" v-if="errors[0]" class="custom-error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>

                        <div class="contenedor-input half">
                            <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                                <input autocomplete="new-password" type="text" name="direction" placeholder="Dirección*"
                                    v-model="data.address" :class="classes">
                                <span v-bind="ariaMsg" v-if="errors[0]" class="custom-error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="campo-texto">
                        <div class="contenedor-input half">
                            <ValidationProvider :rules="'required|min:8'"
                                v-slot="{ errors, ariaInput, ariaMsg, classes }" vid="password">
                                <input autocomplete="new-password" type="password" name="pass" placeholder="Contraseña*"
                                    v-model="data.password" :class="classes">
                                <span v-bind="ariaMsg" v-if="errors[0]" class="custom-error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="contenedor-input half">
                            <ValidationProvider :rules="'required|confirmed:password|min:8'"
                                v-slot="{ errors, ariaInput, ariaMsg, classes }">
                                <input autocomplete="new-password" type="password" name="repite-pass"
                                    placeholder="Repite tu contraseña*" v-model="data.password_confirmation"
                                    :class="classes">
                                <span v-bind="ariaMsg" v-if="errors[0]" class="custom-error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <p><strong>Datos académicos.</strong></p>

                    <div class="contenedor-input row-start only-one-option no-margin">
                        <div class="contenedor-input sinmargen more-options row-start fww ">
                            <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                                <h5>Soy Egresado de la Escuela de Liderazgo Universitario (ELU)*</h5>
                                <div>
                                    <input type="radio" :value="true" name="haselu" id="si"
                                        v-model="data.study[0].haselu">
                                    <label :class="classes" for="si">Sí</label>
                                    <input type="radio" :value="false" name="haselu" id="no"
                                        v-model="data.study[0].haselu">
                                    <label :class="classes" for="no">No</label>
                                </div>
                                <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="contenedor-input " v-if="data.study[0].haselu">
                        <p class="msg-info-tel pt-0">Por favor, indica a continuación los datos de la titulación
                            <strong><u>que cursabas cuando participaste</u></strong> en la ELU. Si eres egresado/a
                            de más de una titulación, podrás incluirla desde tu perfil una vez te hayas registrado.
                        </p>
                        <div class="grupo-form">
                            <div class="contenedor-input full-width">
                                <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                                    <autocomplete :key="'autocomplete-study-noufv'" :class="classes" :name="'study'"
                                        :label="'Titulación*'" :type="'study_noufv'" v-model="data.study[0].study"
                                        :idkey="'id'" @input="setDominioNivel($event)"></autocomplete>
                                    <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{ errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="contenedor-input full-width pt-0">
                                <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                                    <label for="nivel">Nivel*</label>
                                    <select id="nivel" name="nivel" v-model="data.study[0].level" class="pretty"
                                        :class="classes">
                                        <option name="myBrowser" placeholder="" disabled>
                                            <template v-if="data.study[0]['study']">
                                                Selecciona*
                                            </template>
                                            <template v-else>
                                                Selecciona una Titulación*
                                            </template>
                                        </option>
                                        <template v-if="data.study[0]['study']">
                                            <option :key="key" v-for="(nivel, key) in nivelesFiltered" name="myBrowser"
                                                :value="nivel.id">
                                                {{ nivel.value }}
                                            </option>
                                        </template>
                                    </select>
                                    <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="grupo-form">
                            <div class="contenedor-input full-width pt-0">
                                <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                                    <label for="university">Universidad*</label>
                                    <autocomplete :key="'autocomplete-university-noufv'" :formtype="'select'"
                                        :class="classes" :name="'university'" :label="'Universidad*'"
                                        :type="'university_noufv'" :value="data.study[0].university" :idkey="'id'"
                                        @input="setStudyUniversity"></autocomplete>
                                    <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{ errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </div>



                            <div class="contenedor-input half pt-0">
                                <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                                    <year-datepicker :class="classes" :label="'Año de promoción*'" :minpage="new Date()"
                                        v-model="data.study[0].year" :name="'year'"
                                        :maxpage="(data.study[0].level == 3 || data.study[0].level == '3') ? new Date('2009-12-31') : null">
                                    </year-datepicker>

                                    <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="contenedor-input half">
                                <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                                    <year-datepicker :class="classes" :label="'Año de promoción ELU*'"
                                        :minpage="new Date()" v-model="data.study[0].elu_year" :name="'elu_year'">
                                    </year-datepicker>
                                    <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{ errors[0] }}</span>
                                </ValidationProvider>
                                <p class="msg-info-tel pt-0">Es el año en el que finalizaste tus estudios ELU</p>

                            </div>
                        </div>

                    </div>


                    <div class="contenedor-input " v-else>
                        <p class="msg-info-tel espacio">Por favor, indica a continuación los datos de la titulación
                            <strong><u>que has cursado</u></strong> en la UFV. Si eres egresado/a de más de una
                            titulación, podrás incluirla desde tu perfil una vez te hayas registrado.
                        </p>

                        <div class="grupo-form">
                            <div class="contenedor-input full-width ">
                                <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                                    <autocomplete :key="'autocomplete-study-ufv'" :class="classes" :name="'study'"
                                        :label="'Titulación*'" :type="'study_ufv'" v-model="data.study[0].study"
                                        :idkey="'id'" @input="setDominioNivel($event)">
                                    </autocomplete>
                                    <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{ errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="contenedor-input full-width pt-0">
                                <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                                    <label for="nivel">Nivel*</label>
                                    <select id="nivel" name="nivel" v-model="data.study[0].level" class="pretty "
                                        :class="classes">
                                        <option name="myBrowser" placeholder="" disabled>
                                            <template v-if="data.study[0]['study']">
                                                Selecciona*
                                            </template>
                                            <template v-else>
                                                Selecciona una Titulación*
                                            </template>
                                        </option>
                                        <template v-if="data.study[0]['study']">
                                            <option :key="key" v-for="(nivel, key) in nivelesFiltered" name="myBrowser"
                                                :value="nivel.id">
                                                {{ nivel.value }}
                                            </option>
                                        </template>
                                    </select>
                                    <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{ errors[0]
                                    }}</span>
                                    <small v-if="data.study[0].level == 3 || data.study[0].level == '3'"
                                        class="small-info">*Para el nivel
                                        académico seleccionado, recuerda que el año máximo permitido como año de
                                        promoción es 2009</small>
                                </ValidationProvider>
                            </div>
                        </div>

                        <div class="grupo-form">
                            <div class="contenedor-input half pt-0">
                                <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                                    <label for="university">Universidad*</label>
                                    <autocomplete :key="'autocomplete-university-ufv'" :formtype="'select'"
                                        :class="classes" :name="'university'" :label="'Universidad*'"
                                        :type="'university_ufv'" :value="data.study[0].university" :idkey="'id'"
                                        @input="setStudyUniversity"></autocomplete>
                                    <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="contenedor-input half">
                                <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                                    <year-datepicker :class="classes" :label="'Año de promoción*'" :minpage="new Date()"
                                        v-model="data.study[0].year" :name="'year'"
                                        :maxpage="(data.study[0].level == 3 || data.study[0].level == '3') ? new Date('2009-12-31') : null">
                                    </year-datepicker>
                                    <span v-bind="ariaMsg" class="custom-error">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>

                        </div>
                    </div>

                    <div class="text_politica">
                        <p>El responsable del tratamiento de sus datos es la Universidad Francisco de Vitoria (UFV).</p>
                        <p>La finalidad del tratamiento es</p>
                        <div style="padding: 0 15px;">
                            <ul>
                                <li>Enviarle, por cualquier medio, incluidos los electrónicos (SMS, Whatsapp, correo
                                    electrónico y redes sociales), comunicaciones relacionadas con empleabilidad,
                                    observatorio de empleo, ofertas, promociones, productos, actividades, concursos y
                                    servicios de la Universidad Francisco de Vitoria y/o patrocinados por la misma.</li>
                                <li>Gestionar su inscripción en las actividades organizadas por la Universidad Francisco
                                    de Vitoria (UFV).</li>
                                <li>Publicar videos e imágenes en las diferentes páginas webs de la universidad y redes
                                    sociales en las que pueda aparecer a raíz de su participación en las diferentes
                                    actividades de la universidad (conferencias, concursos, etc.). En el caso de que se
                                    le invitara a participar en actuaciones específicas de promoción de la Universidad
                                    Francisco de Vitoria, se le pediría su consentimiento documentalmente si su imagen
                                    tuviera un carácter relevante.</li>
                            </ul>

                        </div>

                        <p>
                            La legitimación del tratamiento se basa en el consentimiento del interesado marcando la
                            casilla destinada a tal efecto, y el interés legítimo del responsable, según se detalla en
                            la información ampliada. Los datos se mantendrán mientras usted no revoque el consentimiento
                            otorgado o no se oponga al tratamiento realizado a través del link:<a
                                href="https://www.alumni-ufv.es/es/general/encuesta-padres"
                                target="_blank">https://www.alumni-ufv.es/es/general/encuesta-padres</a></p>
                        <p>La información facilitada no será comunicada a terceros ajenos a la UFV, salvo a prestadores
                            de servicio con acceso a datos. </p>
                        <p>Puede ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del
                            tratamiento y portabilidad mediante un escrito dirigido a la Secretaría General de la
                            Universidad Francisco de Vitoria, Ctra. M-515 Pozuelo-Majadahonda Km. 1,800; 28223, Pozuelo
                            de Alarcón (Madrid), o al correo electrónico <a href="mailto:dpd@ufv.es.">dpd@ufv.es.</a>
                        </p>
                        <p>
                            Si a través del presente formulario facilita datos de terceras personas, le informamos de
                            que queda obligado a informar al interesado sobre el contenido de esta cláusula.</p>

                        <p>
                            Puede consultar la información ampliada en la web <a
                                href="https://www.ufv.es/politica-privacidad-alumni"
                                target="_blank">https://www.ufv.es/politica-privacidad-alumni</a>
                        </p>


                    </div>

                    <div class="contenedor-input">
                        <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                            <input type="checkbox" id="contact" v-model="data.contact" :class="classes">
                            <label for="contact">Acepto y autorizo a que mis datos sean tratados por la Universidad
                                Francisco
                                de
                                Vitoria, con las finalidades indicadas anteriormente y para remitirme, por cualquier
                                medio,
                                incluidos los electrónicos (SMS, Whatsapp, correo electrónico y redes sociales) las
                                comunicaciones correspondientes.</label>
                            <span v-bind="ariaMsg" v-if="errors[0]" class="custom-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>


                    <div class="full-width row-center">
                        <button class="boton-azul" :loading="loading">Enviar</button>
                    </div>


                </form>
            </ValidationObserver>
        </div>

    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import 'vue2-datepicker/locale/es/es';


export default {
    name: 'registro',
    mounted() {
        this.requestStudyAutocomplete()
    },
    data: () => ({
        data: {
            document: '',
            document_type: '',
            email: '',
            password: '',
            password_confirmation: '',
            name: '',
            surname: '',
            surname_2: '',
            phone: '',
            nationality: '',
            address: '',
            contact: '',
            study: [
                {
                    university: null,
                    study: null,
                    level: '',
                    elu_year: '',
                    year: '',
                    haselu: false
                }
            ]
        },
        loading: false
    }),

    computed: {
        ...mapGetters({
            dominios: 'getDominios', nivelesFiltered: 'getCurrentNiveles'
        }),
        studyHaseluFlag() {
            if (!this.data.study || !this.data.study[0]) {
                return undefined;
            }
            return this.data.study[0].haselu;
        }
    },
    methods: {
        ...mapActions(['createAlumni', 'setNiveles', 'requestStudyAutocomplete']),
        validate() {
            this.$refs.form.validate().then(success => {
                if (success) {
                    this.loading = true;
                    this.createAlumni(this.data).then(r => {
                        this.loading = false;
                        if (r) {
                            window.location.href = 'https://www.ufv.es/otros-servicios/familias-ufv/';
                        }
                    })
                } else {
                    window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
                }
            });
        },
        setDominioNivel(event) {
            this.data.study[0].level = '';
            this.data.study[0].study = event.id
            this.setNiveles(event.levels);
        },
        setStudyUniversity(option) {
            this.data.study[0].university = option && option.id != null ? option.id : null;
        },
    },
    watch: {
        studyHaseluFlag() {
            if (!this.data.study || !this.data.study[0]) {
                return;
            }
            const s = this.data.study[0];
            s.study = null;
            s.level = '';
            s.year = '';
            s.elu_year = '';
            s.university = null;
            this.setNiveles([]);
        }
    }
}
</script>


<style lang="scss" scoped>
.link {
    margin-bottom: 20px;
    text-decoration: underline;

    &.-red {
        color: red;
    }
}

.sinmargen {
    padding-bottom: 0px;
}

.no-margin {
    margin-bottom: 0px;
    padding-bottom: 0px;
    padding-top: 0px;

    .contenedor-input {
        margin-bottom: 0px;
    }
}

.no-margin {
    margin-bottom: 0px;
    padding-bottom: 0px;

    .contenedor-input {
        margin-bottom: 0px;
    }
}
</style>